import React from "react";
import FilterListIcon from '@mui/icons-material/FilterList';
import './FilterIcon.css'

export default function FilterIcon({ inUse = false, onClick }) {
  return (
    <button className="button-border" onClick={onClick}>
      <div className="icon-wrapper">
        <FilterListIcon className="filter-icon" />
        {inUse && <span className="status-dot" />}
      </div>
    </button>
  );
}